export enum SearchOperator {
  BEGINS = 'BEGINS',
  BETWEEN = 'BETWEEN',
  CONTAINS = 'CONTAINS',
  IN = 'IN',
  EQ = 'EQ',
  NE = 'NE',
  GE = 'GE',
  GT = 'GT',
  LE = 'LE',
  LT = 'LT',
  CUSTOM = 'CUSTOM',
  JOIN = 'JOIN',
}
